module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "meiaHeader"
    }
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "headerElement alignCenter",
    attrs: {
      "to": "/"
    }
  }, [_c('h1', {
    attrs: {
      "id": "meia"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "headerElement alignRight"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.goToBottom()
      }
    }
  }, [_vm._v("ABOUT")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "headerElement",
    attrs: {
      "href": "http://www.pzwart.nl/master-education-in-arts/"
    }
  }, [_c('h1', {
    attrs: {
      "id": "pzi"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dd314c1a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/meiaHeader.vue
// module id = 62
// module chunks = 1